/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlTeamDetectionStatistics
 */
export interface ControlTeamDetectionStatistics {
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    automaticallyClosed: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    chatOpsDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    confirmedMalicious: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    containmentDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    escalatedDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    falsePositiveDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    historicDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    potentialChatOpsDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    potentialContainmentDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    potentialEscalatedDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    totalDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    truePositiveDetections: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeamDetectionStatistics
     */
    verdictedMalicious: number;
}

/**
 * Check if a given object implements the ControlTeamDetectionStatistics interface.
 */
export function instanceOfControlTeamDetectionStatistics(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "automaticallyClosed" in value;
    isInstance = isInstance && "chatOpsDetections" in value;
    isInstance = isInstance && "confirmedMalicious" in value;
    isInstance = isInstance && "containmentDetections" in value;
    isInstance = isInstance && "escalatedDetections" in value;
    isInstance = isInstance && "falsePositiveDetections" in value;
    isInstance = isInstance && "historicDetections" in value;
    isInstance = isInstance && "potentialChatOpsDetections" in value;
    isInstance = isInstance && "potentialContainmentDetections" in value;
    isInstance = isInstance && "potentialEscalatedDetections" in value;
    isInstance = isInstance && "totalDetections" in value;
    isInstance = isInstance && "truePositiveDetections" in value;
    isInstance = isInstance && "verdictedMalicious" in value;

    return isInstance;
}

export function ControlTeamDetectionStatisticsFromJSON(json: any): ControlTeamDetectionStatistics {
    return ControlTeamDetectionStatisticsFromJSONTyped(json, false);
}

export function ControlTeamDetectionStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlTeamDetectionStatistics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'automaticallyClosed': json['automaticallyClosed'],
        'chatOpsDetections': json['chatOpsDetections'],
        'confirmedMalicious': json['confirmedMalicious'],
        'containmentDetections': json['containmentDetections'],
        'escalatedDetections': json['escalatedDetections'],
        'falsePositiveDetections': json['falsePositiveDetections'],
        'historicDetections': json['historicDetections'],
        'potentialChatOpsDetections': json['potentialChatOpsDetections'],
        'potentialContainmentDetections': json['potentialContainmentDetections'],
        'potentialEscalatedDetections': json['potentialEscalatedDetections'],
        'totalDetections': json['totalDetections'],
        'truePositiveDetections': json['truePositiveDetections'],
        'verdictedMalicious': json['verdictedMalicious'],
    };
}

export function ControlTeamDetectionStatisticsToJSON(value?: ControlTeamDetectionStatistics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'automaticallyClosed': value.automaticallyClosed,
        'chatOpsDetections': value.chatOpsDetections,
        'confirmedMalicious': value.confirmedMalicious,
        'containmentDetections': value.containmentDetections,
        'escalatedDetections': value.escalatedDetections,
        'falsePositiveDetections': value.falsePositiveDetections,
        'historicDetections': value.historicDetections,
        'potentialChatOpsDetections': value.potentialChatOpsDetections,
        'potentialContainmentDetections': value.potentialContainmentDetections,
        'potentialEscalatedDetections': value.potentialEscalatedDetections,
        'totalDetections': value.totalDetections,
        'truePositiveDetections': value.truePositiveDetections,
        'verdictedMalicious': value.verdictedMalicious,
    };
}

